<template>
  <h-tabs class="login-tabs" v-model="typeValue" :animated="true">
    <h-tab-pane name="0" label="账号密码登录"></h-tab-pane>
    <h-tab-pane name="1" label="手机验证登录"></h-tab-pane>
  </h-tabs>
</template>
<script>

export default {
  name: 'HTabsLogin',
  data () {
    return {
      typeValue: ''
    }
  },
  watch: {
    typeValue (value) {
      this.$emit('input', value)
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.login-tabs {
  min-height: 0 !important;
  height: auto !important;
  -webkit-app-region: no-drag;
  /deep/.h-tabs-bar {
    border: 0;
    margin-bottom: 40px;
  }
  /deep/.h-tabs-nav .h-tabs-tab {
    padding: 10px 0;
    font-size: 14px;
    // margin-right: 20px;
  }
}
</style>